import { LayoutComponent } from '../layout/layout.component';
import { CanActivateViaAuthGuard } from '../guard/can-activate-via-auth.guard';
import { TwofaComponent } from '@app-routes/auth/twofa/twofa.component';
import { Routes } from '@angular/router';

export const routes: Routes = [

    {
        path: '',
        component: LayoutComponent,
        canActivate: [CanActivateViaAuthGuard],
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
            { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
            { path: 'accounts', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
            { path: 'persons', loadChildren: () => import('./person/person.module').then(m => m.PersonModule) },
            { path: 'entries', loadChildren: () => import('./entry/entry.module').then(m => m.EntryModule) },
            { path: 'individual', loadChildren: () => import('./individual/individual.module').then(m => m.IndividualModule) },
            { path: 'consults', loadChildren: () => import('./consult/consult.module').then(m => m.ConsultModule) },
            { path: 'companies', loadChildren: () => import('./company/company.module').then(m => m.CompanyModule) },
            { path: 'fields', loadChildren: () => import('./fields/fields.module').then(m => m.FieldsModule) },
            { path: 'indextype', loadChildren: () => import('./indextype/indextype.module').then(m => m.IndextypeModule) },
            { path: 'zzi', loadChildren: () => import('./zzi/zzi.module').then(m => m.ZziModule) },
            { path: 'declaration', loadChildren: () => import('./declaration/declaration.module').then(m => m.DeclarationModule) },
            { path: 'bi', loadChildren: () => import('./bi/bi.module').then(m => m.BiModule) },
            { path: 'pib', loadChildren: () => import('./pib/pib.module').then(m => m.PibModule) },
            { path: 'pib-individual', loadChildren: () => import('./pib-individual/pib-individual.module').then(m => m.PibIndividualModule) },
            { path: 'webshop', loadChildren: () => import('./webshop/webshop.module').then(m => m.WebshopModule) }
        ]
    },
    {
        path: '2fa',
        component: TwofaComponent
    },

    // Not found
    { path: '**', redirectTo: 'home' }

];
